import { useWorkorderBaseRoute } from 'utils/Subscription/pathAndRouteSelector'
import { useRouteMatch } from 'react-router-dom'
import { UUIDPathRegex } from '@cbgms/base/utils/uuid'

/**
 * useGetCurrentOpenOrder will return the current open order. if none exists will return null
 */
export const useGetCurrentOpenOrder = (): string | null => {
  const basePath = useWorkorderBaseRoute()
  const match = useRouteMatch<{ workorderUUID: string }>(`${basePath}:workorderUUID(${UUIDPathRegex})`)
  if (!match || !match?.params?.workorderUUID) {
    return null
  }

  return match.params.workorderUUID
}
